const ScrollTo = {
  mounted() {
    this.handleEvent("scroll-to-end", (detail) => {
      const options = {
        behavior: "smooth",
        ...detail,
        top: this.el.scrollHeight,
      }
      this.el.scrollTo(options)
    })
  },
}

export default ScrollTo
